module.exports = __webpack_public_path__ + "img/35.af84d7b5.png";